import React, { useEffect, useState } from "react";
import Iframe from "react-iframe";
import "./game.scss";
import { useDispatch, useSelector } from "react-redux";
import LoginModal from "../../modal/login_modal/LoginModal";
import { ENUM_BOT_THEME } from "../../../store/enums";
import ErrorGameModal from "../../modal/error_game_modal/ErrorGameModal";
import useRunGame from "../../../hooks/useRunGame";
import ConfirmCloseModal from "../../modal/error_game_modal/ConfirmCloseModal";
import { setRunningGame } from "../../../store/siteSlice";
import { dispatchCusEvent, getParamFromUrl } from "../../../utils/utils";
import { ENUM_TAWK_API } from "../../../hooks/other/useTawkController";
import { setHardModeGame } from "../../../store/commonSlice";

export default function GameContainer({ uid = "", gameId = "", currentGame, isBonus }) {
  const theme = useSelector((state) => state.common.botTheme);
  const dispatch = useDispatch();
  const [openLogin, setOpenLogin] = useState(false);
  const [isOpenConfirmClose, setIsOpenConfirmClose] = useState(false);
  const [errorMes, setErrorMes] = useState("");
  const [justCame, setJustCame] = useState(false);

  const { onCloseGame, hideCross, iframeSrc } = useRunGame({
    setOpenLogin,
    setJustCame,
    setErrorMes,
    currentGame,
    uid,
    isBonus,
    gameId,
    justCame
  });

  useEffect(() => {
    dispatch(setRunningGame(true));
    dispatchCusEvent(ENUM_TAWK_API.hide);
    return () => {
      dispatch(setRunningGame(false));
      dispatchCusEvent(ENUM_TAWK_API.show);
      const mode = getParamFromUrl("mode");
      dispatch(setHardModeGame(mode));
    };
  }, []);

  const closeLogin = () => {
    if (theme === ENUM_BOT_THEME.telegram) return;
    if (!justCame) onCloseGame();
    setOpenLogin(false);
  };

  const closeError = () => {
    onCloseGame();
    setErrorMes("");
  };

  return (
    <div className="game">
      <Iframe
        display="block"
        className="game-iframe"
        scrolling="no"
        allow="fullscreen; geolocation; microphone; camera; display-capture;"
        allowFullScreen={true}
        src={iframeSrc}
      />

      <button className="game__close-btn" onClick={() => setIsOpenConfirmClose(true)}>
        x
      </button>
      <LoginModal
        isOpen={openLogin}
        closeModal={(e) => {
          if (e === true) {
            console.log("aut");
            setJustCame(true);
            setOpenLogin(false);
            return;
          }
          closeLogin();
        }}
        hideCross={hideCross}
      />
      <ErrorGameModal
        isOpen={!!errorMes}
        message={errorMes}
        closeModal={closeError}
        currentGame={currentGame}
      />
      <ConfirmCloseModal
        isOpen={isOpenConfirmClose}
        closeModal={() => setIsOpenConfirmClose(false)}
        onConfirm={onCloseGame}
        currentGame={currentGame}
      />
    </div>
  );
}
